import React from 'react';
import { Reveal } from './ui/Reveal';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-brand-sand" data-id="element-75">
      <div className="max-w-4xl mx-auto px-6" data-id="element-76">
        <Reveal data-id="element-77">
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border-2 border-brand-sage/20 flex flex-col md:flex-row items-center gap-8 text-center md:text-left" data-id="element-78">
            <div className="w-24 h-24 bg-brand-sage/20 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-79">
              <ShieldCheck className="w-12 h-12 text-brand-forest" data-id="element-80" />
            </div>
            <div data-id="element-81">
              <h3 className="text-2xl font-bold mb-3" data-id="element-82">
                Garantía Total de 7 Días
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-83">
                Estoy tan segura de que este método transformará tu vida, que te
                ofrezco una garantía incondicional. Accede hoy, revisa el
                material, prueba las recetas. Si en 7 días sientes que esto no
                es para ti, te devuelvo el 100% de tu dinero. Sin preguntas, sin
                complicaciones.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}